export const environment = "prod";


let apiUrl;
let genaiUrl;
if (environment === "local" || environment === "dev") {
  apiUrl =  "https://backend.release-calendar-dev.autodesk.com/api/erc";
  genaiUrl= "https://fr6trfj4z7.execute-api.us-west-2.amazonaws.com/v1/genai";
} else if (environment === "prod"  || environment === "preprod") {
  apiUrl = "https://backend.release-calendar.autodesk.com/api/erc";
  genaiUrl="https://ef816l3lec.execute-api.us-east-1.amazonaws.com/v1/genai";
}

export const REACT_APP_API = apiUrl;
export const GENAI_URL = genaiUrl;
export const REACT_APP_LOCAL_USER_EMAIL = '';
export const REACT_APP_LOCAL_USER_NAME = '';
let token = "";
let aws_token = ""

if (environment === "local") {
  sessionStorage.setItem("email", REACT_APP_LOCAL_USER_EMAIL);
  sessionStorage.setItem("username", REACT_APP_LOCAL_USER_NAME);
  sessionStorage.setItem("isLoggedIn", true);
  sessionStorage.setItem("token", token);
  sessionStorage.setItem("aws_token", aws_token);
}